<template>
    <div></div>
</template>

<script>
import { SSOLogin } from "@/api/login";

export default {
    name: 'SSOLogin',
    data() {
        return {}
    },
    created() {
        this.openFullScreen()
    },
    methods: {
        //全屏显示加载中
        async openFullScreen() {
            const loading = this.$loading({
                lock: true,
                text: '加载中,请稍后...',
                spinner: 'el-icon-loading',
                customClass: 'create-isLoading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            //没有sso的票据信息，重新验证权限
            if (!this.$route.query.token) {
                location.href = '/Login'
                loading.close()
                return
            }
            //将票据传到后台进行校验
            await SSOLogin(this.$route.query.token).then((res) => {
                loading.close()
                this.$store.commit("setToken", res.token)
                this.$router.push({ path: this.$route.query.path || "/Home" }).catch(() => { })
                this.$store.commit("setMenusActive", '/' + this.$route.query.path)
                this.$store.commit("setMenusActives", this.getParentMenu(this.$route.query.path))
            }).catch(() => {
                loading.close()
            })
        },
        getParentMenu(children) {
            const menu = [
                {key: 'DeviceMsg', value: ['/DeviceManagement']},
                {key: 'DeviceOutManagement', value: ['/DeviceManagement']},
                {key: 'BusinessDataMonitor', value: ['/BusinessDataManagement']},
                {key: 'BusinessDataStatistics', value: ['/BusinessDataManagement']},
                {key: 'BusinessDataGroupStatistics', value: ['/BusinessDataManagement']},
                {key: 'BusinessDataSynchronization', value: ['/BusinessDataManagement']},
                {key: 'SeeCloudLog', value: ['/SeeLog']},
                {key: 'CollectionLog', value: ['/SeeLog']},
                {key: 'HandleCodeParamsSetAndSync', value: ['/ParamsSetAndSync']},
                {key: 'DeviceStatusManagement', value: ['/DeviceRunManagement']},
                {key: 'ElectronicScaleThemeLibrary', value: ['/DeviceRunManagement']},
                {key: 'UpdateManagement', value: ['/CollectionSystemSetUpManagement']}
            ]
            for (let c of menu) {
                if (c.key == children) {
                    c.value.push('/' + children)
                    return c.value
                }
            }
        }
    }
}
</script>

<style lang="scss">

    .create-isLoading {
        .el-loading-spinner {
            top: 50%;
            left: 50%;
            margin-left: -55px;
            background: rgba(0, 0, 0, 0.7);
            padding: 20px;
            border-radius: 4px;
            width: auto;
            text-align: center;
            position: absolute;

            i {
                color: #eee;
            }

            .el-loading-text {
                color: #eee;
                font-size: 20px;
            }
        }
    }

</style>
